export default "__VITE_ASSET__CLmTzvZG__"